import { mapQuery } from 'utils/query';
import { Details } from 'components/details';
import { useDetailsQuery } from 'store/api/payout';
import { BackCategoryButton } from 'components/back-category-button';
import { ReimbursementDetails as ReimbursementDetailsComponent } from 'components/reimbursement-details';

import { ReimbursementDetailsProps } from './types';

export const ReimbursementDetails = ({
  onClose,
  selectedReimbursementId,
}: ReimbursementDetailsProps) => {
  const { data, ...props } = useDetailsQuery(String(selectedReimbursementId), {
    skip: !selectedReimbursementId,
  });

  return (
    <Details {...mapQuery(props)}>
      <BackCategoryButton onClose={onClose} />
      <ReimbursementDetailsComponent data={data} disableSticky hideBackButton />
    </Details>
  );
};
